import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './lib/sentry';

import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

// Sentry 초기화 (앱 렌더링 전에 실행)
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
